module.exports = __webpack_public_path__ + "img/con1-extra.85268bb9.png";